import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSocketContext } from "./SocketContext";
import { toast } from "react-toastify";
import welcomeMessage from "./assets/audios/messageTone.mp3";
import errorTone from "./assets/audios/error_tone.mp3";
import ProfileImage from "./components/ProfileImage";

const useListenMessages = () => {
  const { socket } = useSocketContext();
  const { userInfo } = useSelector((state) => state.auth);
  const [isToggled, setIsToggled] = useState(userInfo?.audioOn);

  useEffect(() => {
    if (!socket) return;

    const handleNewMessage = (newAtt) => {
      console.log(new Date().getMinutes() + " : " + new Date().getSeconds());
      console.log(newAtt);
      toast.success(
        () => (
          <div
            style={{
              padding: "20px",
              fontSize: "1.2em",
              lineHeight: "1.5",
              textAlign: "center", // Center align the content
              position: "relative", // Required for overlay graphics
              // background: "linear-gradient(135deg, #ff9a9e, #fad0c4)", // Gradient background
              borderRadius: "15px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              overflow: "hidden",
            }}
          >
            {/* Play Birthday Tone */}
            <audio
              src={welcomeMessage}
              type="audio/mp3"
              autoPlay={isToggled}
            ></audio>
            {/* Display Profile Image */}
            <ProfileImage
              style={{
                margin: "10px 0",
                borderRadius: "50%",
              }}
              imageId={userInfo.gymId._id + "" + newAtt?.userId}
            />
            <br />
            <strong style={{ fontSize: "1.5em" }}>
              {newAtt?.message} {newAtt?.userName}
            </strong>
            <strong>
              <p style={{ color: "green" }}>
                {newAtt?.message?.includes("Bye") &&
                  "Workout Minutes : " +
                    (
                      (Number(newAtt?.timeOut) - Number(newAtt?.timeIn)) /
                      60000
                    ).toFixed(0)}
              </p>
            </strong>
            <p style={{ fontSize: "1em" }}>
              Valid Till : {newAtt?.expiresOn?.split("T")[0]}
              <br />
              Expires in{" "}
              {Math.ceil(
                (new Date(newAtt?.expiresOn) - new Date()) /
                  (1000 * 60 * 60 * 24)
              ) === 0
                ? "Expiring Today"
                : Math.ceil(
                    (new Date(newAtt?.expiresOn) - new Date()) /
                      (1000 * 60 * 60 * 24)
                  ) + " days"}
            </p>{" "}
            {newAtt?.pendingAmount > 0 && (
              <label style={{ color: "red" }}>
                Pending Amount : {newAtt?.pendingAmount}
              </label>
            )}
          </div>
        ),
        {
          style: {
            width: userInfo?.isMobileScreen ? "350px" : "500px",
          },
        }
      );
    };

    // Attach listener
    socket.on("newMessage", handleNewMessage);

    // Cleanup listener
    return () => {
      socket.off("newMessage", handleNewMessage);
    };
  }, [socket]);
};
export default useListenMessages;
